import {
  ExtractDocumentTypeFromTypedRxJsonSchema,
  RxJsonSchema,
  toTypedRxJsonSchema,
} from 'rxdb'

export const assignment = {
  version: 0,
  title: 'Assignment',
  primaryKey: 'rowId',
  type: 'object',
  properties: {
    rowId: {
      maxLength: 36,
      type: 'string',
    },
    appUserId: {
      type: 'string',
    },
    updatedAt: {
      type: 'string',
    },
    appointmentAt: {
      type: ['string', 'null'],
    },
  },
  required: ['rowId', 'appointmentAt', 'updatedAt'],
} as const

const schemaTyped = toTypedRxJsonSchema(assignment)

export type Assignment = ExtractDocumentTypeFromTypedRxJsonSchema<
  typeof schemaTyped
>

export const assignmentSchema: RxJsonSchema<Assignment> = assignment
